import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faSave,
  faCheck,
  faXmark,
  faFileLines,
  faArrowUp,
  faArrowDown, faCopy,
} from "@fortawesome/free-solid-svg-icons";

const BrandTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  hideChangeLog,
}) => {
  // ✅ SORT STATE
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  // ✅ HANDLE SORT
  const handleSort = (header) => {
    setSortConfig((prev) => ({
      key: header,
      direction:
        prev.key === header && prev.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

    const [copiedId, setCopiedId] = useState(null);

  // ✅ HANDLE COPY
 const handleCopy = async (url, id) => {
  try {
    // Modern Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
    } else {
      // Fallback
      const textArea = document.createElement("textarea");
      textArea.value = url;

      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";

      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();

      document.execCommand("copy");

      textArea.remove();
    }

    setCopiedId(id);

    setTimeout(() => {
      setCopiedId(null);
    }, 1500);

  } catch (error) {
    console.log("Copy failed", error);
  }
};
  

  // ✅ SORTED ROWS
  const sortedRows = useMemo(() => {
    let sorted = [...rows];

    if (!sortConfig.key) return sorted;

    sorted.sort((a, b) => {
      const aVal = a[sortConfig.key] === true ? 1 : 0;
      const bVal = b[sortConfig.key] === true ? 1 : 0;

      if (sortConfig.direction === "asc") {
        return bVal - aVal; // true first
      } else {
        return aVal - bVal; // false first
      }
    });

    return sorted;
  }, [rows, sortConfig]);

  return (
    <div className="tableContainer">
      <table className="table text-xs w-[88vw]" role="table">
        <thead className="stickyHeader bg-[var(--mainCol)] text-white">
          <tr>
            {headers?.map((header, index) => {
              return (
                <th className="p-1 text-left border" key={index}>
                  <div className="flex items-center gap-1">
                    {header.toUpperCase()}

                    {/* ✅ SORT ICON */}
                    {(
                      header === "is_read" ||
                      header === "status" ||
                      header === "is_Start" ||
                      header === "is_Finshed") && (
                      <div
                        className="ml-1 cursor-pointer flex items-center"
                        onClick={() => handleSort(header)}
                      >
                        <FontAwesomeIcon
                          icon={
                            sortConfig.key === header &&
                            sortConfig.direction === "asc"
                              ? faArrowUp
                              : faArrowDown
                          }
                          className="text-[12px] text-white"
                        />
                      </div>
                    )}
                  </div>
                </th>
              );
            })}

            {/* <th
              style={{ background: "var(--mainCol)" }}
              className="p-1 text-left border stickyActionColumn z-100"
            >
              ACTION
            </th> */}
          </tr>
        </thead>

        <tbody>
          {/* ✅ SORTED ROWS */}
          {sortedRows?.map((row) => (
            <tr key={row.id}>
              {headers.map((header) => (
                <td key={header} className="p-3 border">
                  {editRowId === row.id &&
                  editableFields?.includes(header) ? (
                    header === "active" ||
                    header === "is_active" ||
                    header === "status" ||
                    header === "queryInProgress" ||
                    header === "is_read" ||
                    header === "is_Finshed" ||
                    header === "is_Start" ||
                    header === "queryResolve" ? (
                      <div className="cursor-pointer flex justify-center">
                        {editedData[header] === true && (
                          <FontAwesomeIcon
                            onClick={(e) =>
                              handleChange(e, header, true)
                            }
                            color="var(--green_Main)"
                            icon={faCheck}
                            
                          />
                        )}

                        {editedData[header] === false && (
                          <FontAwesomeIcon
                            onClick={(e) =>
                              handleChange(e, header, false)
                            }
                            color="indianred"
                            icon={faXmark}
                          />
                        )}
                      </div>
                    ) : (
                      <input
                        type="text"
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        onKeyUp={(e) =>
                          e.key === "Enter" && handleSave()
                        }
                        className="w-full p-1 border"
                      />
                    )

                 ) : header === "logo" ? (

                    /* ✅ LOGO IMAGE + COPY */
                    <div className="flex items-center flex justify-between">
                      <img
                        src={row[header]}
                        alt="logo"
                        className="w-14 h-14 object-contain border rounded cursor-pointer p-1"
                        onClick={() =>
                          window.open(row[header], "_blank")
                        }
                        onError={(e) => {
                          e.target.src =
                            "https://via.placeholder.com/40";
                        }}
                      />

                      <div
                        className="cursor-pointer"
                        onClick={() =>
                          handleCopy(row[header], row.id)
                        }
                      >
                        {copiedId === row.id ? (
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="text-green-600"
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faCopy}
                            className="text-blue-600"
                          />
                        )}
                      </div>
                    </div>

                  ) : row[header] === true ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="var(--green_Main)"
                      icon={faCheck}
                    />
                  ) : row[header] === false ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="indianred"
                      icon={faXmark}
                    />
                  ) : (
                    String(row[header])
                  )}
                </td>
              ))}

              {/* <td className="p-2 border stickyActionColumn">
                {editRowId === row.id ? (
                  <div className="flex justify-center">
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="#67a97b"
                      onClick={handleSave}
                      icon={faSave}
                    />

                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="indianred"
                      onClick={handleCancel}
                      icon={faXmark}
                    />
                  </div>
                ) : (
                  <div className="flex justify-center z-100">
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      onClick={() => handleEdit(row.id)}
                      icon={faPenToSquare}
                    />

                    {!hideChangeLog && (
                      <FontAwesomeIcon
                        className="ml-2 cursor-pointer"
                        onClick={() => handleLog(row.id)}
                        icon={faFileLines}
                      />
                    )}
                  </div>
                )}
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BrandTable;
